/**
 *
 * @param {void} callback - функция вызываемая при событии скролл
 * @param {HTMLDivElement} target - элемент в котором происходит скролл
 */
const infifniteScroll = (callback: () => void, target: HTMLDivElement): void => {
    if (!callback || !target) {
        throw new Error('Не переданы аргументы в функцию');
    }

    if (typeof callback !== 'function' || !(target instanceof HTMLDivElement)) {
        throw new TypeError('Некорректный тип аргументов');
    }

    const { scrollTop, scrollHeight, clientHeight } = target;

    if (scrollTop + clientHeight >= scrollHeight) {
        callback();
    }
};

export default infifniteScroll;
